import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowDownIconSvg from './icon-arrow-down.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowDownIconSvg {...validProps} />;
}
SvgComponent.iconName = 'arrowDownIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ArrowDownIcon = svgIconWrapper(SvgComponent);
